import { render, staticRenderFns } from "./DamageForm.vue?vue&type=template&id=67691f4a"
import script from "./DamageForm.vue?vue&type=script&lang=js"
export * from "./DamageForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports